export const SNACKBAR_DEFAULT_SHOW_DURATION = 5000;
//# sourceMappingURL=types.js.map